import React, { useState } from "react"
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuPopover,
  MenuItems,
} from "@reach/menu-button"
import { imageItemTransformer } from "../utils/transformers"

import Image from "./ImageOptim"

const SocialLinks = ({ global, className }) => {
  const linkedinUrl = global.elements.linkedin_url.value
  const youtubeUrl = global.elements.youtube_url.value
  const weChatQRCode = global.elements.wechat_qr_code.value?.[0]

  return (
    <ul className={className}>
      {/* in the cn lang model, this is defined. 
      This stops it from attempting to display in non-CN languages, but will change if we add it to other languages. */}
      <Menu>
        {weChatQRCode ? (
          <li className="pl-4">
            <MenuButton>
              <i
                className={`icon-wechat text-2xl leading-none`}
                label="Weixin"
              />
            </MenuButton>
            <MenuPopover>
              <div className="w-32 rounded-sm my-4 p-1.5 shadow-md border bg-white border-gray-300">
                <Image
                  {...imageItemTransformer(weChatQRCode)}
                  cropWidth={116}
                />
              </div>
            </MenuPopover>
          </li>
        ) : null}
      </Menu>
      {linkedinUrl ? (
        <li className="pl-4">
          <SocialLink url={linkedinUrl} icon={`linkedin`} label={"LinkedIn"} />
        </li>
      ) : null}
      {youtubeUrl ? (
        <li className="pl-4">
          <SocialLink url={youtubeUrl} icon={`youtube`} label={"YouTube"} />
        </li>
      ) : null}
    </ul>
  )
}

const SocialLink = ({ icon, url, label }) => {
  return (
    <a
      aria-label={label}
      href={url}
      className={`inline-block`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <i
        className={`icon-${icon} text-2xl leading-none`}
        aria-hidden="true"
      ></i>
    </a>
  )
}

export default SocialLinks
